import React from 'react';
import { RowEdit } from '../../common/DataTable/RowEdit';
import { Button, Grid, Stack, Typography } from '@mui/material';
import dayjs from 'dayjs';
import { Time } from '../../common/MomentTime';
import { isMeetingReadyToStart } from '../../MyCourses/CCT/utils';

export const getColumns = ({ id, codecs }) => [
  {
    field: 'topic',
    headerName: 'Meeting Topic',
    width: 300,
  },
  {
    field: 'isAdhoc',
    headerName: 'Adhoc',
    renderCell: (params) => (params.row.isAdhoc ? 'Yes' : 'No'),
  },
  {
    field: 'codecs',
    headerName: 'Codecs',
    width: 320,
    renderCell: (params) => (
      <>
        {params.row.codecs?.map((codec, index) => {
          return (
            <Grid id={`${id}__grid_container_${index}`} key={index} container>
              <Grid id={`${id}__grid_item_systemName_${index}`} item flexGrow={1}>
                <Typography id={`${id}__text_systemName_${index}`} variant="small">
                  {codecs[codec.data.codecsId]?.SYSTEM_NAME}
                </Typography>
              </Grid>
              <Grid item id={`${id}__grid_item_date_${index}`}>
                <Typography id={`${id}__text_date_${index}`} variant="small">
                  {dayjs(codec.data.startDate).format('MM/DD')}
                  {' - '}
                  {dayjs(codec.data.endDate).format('MM/DD')}
                </Typography>
              </Grid>
            </Grid>
          );
        })}
      </>
    ),
  },
  {
    field: 'host_email',
    headerName: 'Host',
    width: 225,
    valueGetter: (value, row) => (row.queued ? row.username : row.host_email),
  },
  {
    field: 'alternative_hosts',
    headerName: 'Alternate Host',
    width: 225,
    valueGetter: (value, row) => row.settings.alternative_hosts,
  },
  {
    field: 'start_time',
    headerName: 'Start Date and Time (EST)',
    width: 230,
    valueGetter: (value, row) =>
      `${Time.University(row.start_time).format('YYYY-MM-DD @ HH:mm')} (${row.duration}mins)`,
  },
  {
    field: 'id',
    headerName: 'Meeting ID',
    width: 150,
    valueGetter: (value, row) => (row.queued ? 'Being processed...' : row.id),
  },
  {
    field: 'password',
    headerName: 'Password',
    width: 150,
  },
];

export const getFutureMeetingsColumns = ({
  id,
  meetingMenu,
  isPastMeetings = false,
  onStart,
  onDelete,
  codecs,
}) => {
  const columns = [
    {
      field: 'edit',
      headerName: '',
      width: 65,
      sortable: false,
      disableColumnMenu: true,
      resizable: false,
      cellClassName: 'edit-cell',
      headerClassName: 'edit-cell-header',
      renderCell: (params) => {
        return !isPastMeetings && <RowEdit rowData={params.row} actions={meetingMenu} />;
      },
    },
  ];
  return columns.concat(getColumns({ id, codecs })).concat([
    {
      field: 'status',
      headerName: 'Status',
      width: 200,
    },
    {
      field: 'action',
      headerName: 'Action',
      sortable: false,
      disableColumnMenu: true,
      resizable: false,
      width: 180,
      renderCell: (params) => {
        return (
          <Stack
            id={id + '__stack_actionsWrapper'}
            direction={{ xs: 'column', md: 'row' }}
            spacing={1}
          >
            <Button
              variant="outlined"
              onClick={() => onStart(params.row)}
              className="myOdu__button secondary"
              id={id + '__button_start'}
              disabled={params.row.queued || !isMeetingReadyToStart(params.row)}
            >
              Start
            </Button>
            <Button
              variant="outlined"
              onClick={() => onDelete(params.row)}
              className="myOdu__button secondary"
              id={id + '__button_delete'}
            >
              Delete
            </Button>
          </Stack>
        );
      },
    },
  ]);
};

export const getCodecsColumns = ({ id, onDelete }) => {
  return [
    {
      field: 'codecsId',
      headerName: 'Codecs Id',
      flex: 1,
    },
    {
      field: 'systemName',
      headerName: 'System Name',
      flex: 1,
    },
    {
      field: 'startDate',
      headerName: 'Start Date',
      flex: 1,
      valueFormatter: (value) => Time.University(value).format('MM/DD/YYYY'),
    },
    {
      field: 'endDate',
      headerName: 'End Date',
      flex: 1,
      valueFormatter: (value) => Time.University(value).format('MM/DD/YYYY'),
    },
    {
      field: 'action',
      headerName: 'Action',
      flex: 1,
      sortable: false,
      disableColumnMenu: true,
      resizable: false,
      renderCell: (params) => {
        return (
          <Button
            variant="outlined"
            onClick={() => onDelete(params.row)}
            className="myOdu__button secondary"
            id={id + '__button_delete'}
          >
            Delete
          </Button>
        );
      },
    },
  ];
};
